import type { FunctionComponent, ReactNode } from 'react';

import { useChatSlice } from '../../../store/slices/chat/selectors';
import { ChatTabType } from '../../../store/slices/chat/types';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useHeaderSlice } from '../../../store/slices/header/selectors';
import { L12nText } from '../../text/L12nText';

import { NavPages } from './NavPagesConnected';

import styles from './NavPagesTitle.module.css';

export const NavPagesTitleConnected: FunctionComponent = () => {
  const routeLevelLength = useHeaderSlice.getNavRouteLevel();
  const currentNavRoute = useHeaderSlice.getNavRouteByLevel(routeLevelLength);
  const routeByLevel = useHeaderSlice.getNavRouteByLevel(2);
  const playerName = useConfigSlice.playerConfig()?.screenName;
  const isLiveSupportChatTabSelected = useChatSlice.getSelectedTab() === ChatTabType.LiveSupportChat;

  return ((): ReactNode => {
    switch (routeByLevel) {
      case NavPages.CHAT:
        return (
          <span className={styles.navPagesTitle__main}>
            <L12nText tk={`${isLiveSupportChatTabSelected ? 'LIVE_SUPPORT' : 'CHAT'}`} />
          </span>
        );
      case NavPages.SETTINGS:
        return (
          <span className={styles.navPagesTitle__main}>
            <L12nText tk={currentNavRoute || 'SETTINGS'} />
          </span>
        );
      case NavPages.HISTORY:
        return (
          <>
            <span className={styles.navPagesTitle__main}>
              <L12nText tk="HISTORY" />:
            </span>{' '}
            {playerName}
          </>
        );
      case NavPages.BET_LIMITS:
        return (
          <span className={styles.navPagesTitle__main}>
            <L12nText tk="BETLIMITSANDPAYOUTS" />
          </span>
        );
      case NavPages.HELP:
        return (
          <span className={styles.navPagesTitle__main}>
            <L12nText tk="HELP" />
          </span>
        );
      case NavPages.QUICK_GUIDE:
        return (
          <span className={styles.navPagesTitle__main}>
            <L12nText tk="QG_QUICK_GUIDE" />
          </span>
        );
      default:
        return (
          <span className={styles.navPagesTitle__main}>
            <L12nText tk="MENU" />
          </span>
        );
    }
  })();
};
